import { isAnyOf } from "@reduxjs/toolkit";
import {
  addFeatureFlagsStorage,
  getFeatureFlagsStorage
} from "../../utils/localStorage/featureFlagsStorage";
import type { RootState } from "../store";
import { listenerMiddleware } from "../listenerMiddleware";
import {
  featureFlagToggled,
  featureFlagsChanged,
  featureFlagsLoadRequested,
  storedFeatureFlagsLoaded
} from "../slices/featureFlagsSlice";

export const registerFeatureFlagsListeners = () => {
  listenerMiddleware.startListening({
    actionCreator: featureFlagsLoadRequested,
    effect: async (_, { dispatch }) => {
      const flags = await getFeatureFlagsStorage();
      dispatch(storedFeatureFlagsLoaded(flags));
    }
  });

  listenerMiddleware.startListening({
    matcher: isAnyOf(featureFlagsChanged, featureFlagToggled),
    effect: async (_, { getState }) => {
      const state = getState() as RootState;
      await addFeatureFlagsStorage(state.featureFlags.flags);
    }
  });
};
